import React from "react";
import "../../assests/css/VehiclePage.css";

const menuItems = [
  // {
  //   icon: "🚗",
  //   title: "Cars for Sale",
  //   tab: "cars-for-sale",
  // },
  // {
  //   icon: "🚚",
  //   title: "Commercial Hiring",
  //   tab: "commercial-hiring",
  // },
  // {
  //   icon: "🔑",
  //   title: "Cars for Rent",
  //   tab: "cars-for-rent",
  // },
 {
    icon: "🏙️",
    title: "City Tours",
    tab: "city-tours",
},
{
  icon: "✈️",
  title: "Airport Transfer",
  tab: "airport-transfer",
},
  {
  icon: "🚘",
  title: "Ride Booking",
  tab: "limousine-booking",
},
  // {
  //   icon: "👤",
  //   title: "Search for Drivers",
  //   tab: "search-drivers",
  // },
];

function Vehicle({ activeTab, onTabChange }) {
  return (
    <div className="vehicle-page">

      <header className="top-navbar">

        <div className="navbar-container">

          {menuItems.map((item, index) => (

            <button
              type="button"
              key={index}
              className={`nav-item ${
                activeTab === item.tab ? "active" : ""
              }`}
              onClick={() => onTabChange(item.tab)}
            >

              <span className="nav-icon">
                {item.icon}
              </span>

              <span className="nav-title">
                {item.title}
              </span>

            </button>

          ))}

        </div>

      </header>

    </div>
  );
}

export default Vehicle;